import { combineReducers } from 'redux-immutable';
import products from 'axp-product-ducks';
import productsV1 from '@americanexpress/product-ducks';
import { graphqlReducer } from 'iguazu-graphql';
import { resourcesReducer } from 'iguazu-rest';
import { proceduresReducer } from 'iguazu-rpc';
import { experimentConfigReducer } from '@americanexpress/one-xp-client-sdk';
import tenancyLocale from './tenancyLocale';
import highVolOrAamReducer from './highVolAamReducer';
import eligibilitiesReducer from './eligibilitiesReducer';
import composeReducers from '../utils/composeReducers';
import appAppearanceReducer from './appAppearanceReducer';

export default combineReducers({
  products: composeReducers(products, productsV1),
  tenancyLocale,
  highVolOrAAM: highVolOrAamReducer,
  iguazuGraphQL: graphqlReducer,
  resources: resourcesReducer,
  procedures: proceduresReducer,
  eligibilities: eligibilitiesReducer,
  experimentConfig: experimentConfigReducer,
  appearance: appAppearanceReducer,
});
